import React, { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import InterceptChat from "../shared/InterceptChat.jsx";
import {
  INTERCEPT_BEATS,
  INTERCEPT_HEADLINE,
  INTERCEPT_PAYOFF,
  INTERCEPT_SCAN_TAG,
  INTERCEPT_STAMP,
  INTERCEPT_SUBHEAD,
} from "../shared/interceptContent.js";

const QuietInterceptSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const reduceMotion = useReducedMotion();

  return (
    <section
      className="cursor-section cursor-intercept-section"
      data-testid="quiet-intercept-section"
      ref={ref}
    >
      <div className="cursor-intercept-inner">
        <div className="cursor-intercept-grid">
          <div className="cursor-intercept-phone-col">
            <InterceptChat />
            <p className="cursor-intercept-phone-caption">
              Live intercept · After hours · Real conversation flow
            </p>
          </div>

          <div className="cursor-intercept-content-col">
            <div className="cursor-intercept-badges">
              <span className="cursor-intercept-stamp">{INTERCEPT_STAMP}</span>
              <span className="cursor-intercept-scan-tag">{INTERCEPT_SCAN_TAG}</span>
            </div>

            <h2 className="cursor-intercept-headline" data-testid="quiet-intercept-headline">
              {INTERCEPT_HEADLINE.lead}
              <br />
              <span className="cursor-intercept-headline-accent">{INTERCEPT_HEADLINE.accent}</span>
            </h2>

            <p className="cursor-intercept-subhead">{INTERCEPT_SUBHEAD}</p>

            <div className="cursor-intercept-beats" data-testid="quiet-intercept-metrics">
              <div className="cursor-intercept-beats-line" aria-hidden="true" />

              <div className="cursor-intercept-beats-list">
                {INTERCEPT_BEATS.map((beat, index) => {
                  const isHero = beat.highlight;
                  const isOutcome = beat.outcome;

                  return (
                    <motion.article
                      key={beat.id}
                      initial={reduceMotion ? false : { opacity: 0, x: 12 }}
                      animate={
                        reduceMotion || isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 12 }
                      }
                      transition={{ duration: 0.4, delay: index * 0.1 }}
                      className={`cursor-intercept-beat${isHero ? " cursor-intercept-beat-hero" : ""}`}
                      data-testid={`quiet-intercept-metric-${beat.id}`}
                    >
                      <div
                        className={`cursor-intercept-beat-marker${
                          isHero ? " cursor-intercept-beat-marker-hero" : ""
                        }`}
                        aria-hidden="true"
                      />

                      <div
                        className={`cursor-intercept-beat-card${
                          isHero ? " cursor-intercept-beat-card-hero" : ""
                        }`}
                      >
                        {isHero && (
                          <span className="cursor-intercept-beat-key">KEY MOMENT</span>
                        )}

                        <p
                          className={`cursor-intercept-beat-value${
                            isHero
                              ? " cursor-intercept-beat-value-hero"
                              : isOutcome
                                ? " cursor-intercept-beat-value-outcome"
                                : ""
                          }`}
                        >
                          {beat.value}
                        </p>
                        <p className="cursor-intercept-beat-detail">{beat.detail}</p>
                      </div>
                    </motion.article>
                  );
                })}
              </div>
            </div>

            <div className="cursor-intercept-payoff" data-testid="quiet-intercept-payoff">
              <div className="cursor-intercept-payoff-line" aria-hidden="true" />
              <p className="cursor-intercept-payoff-text">
                {INTERCEPT_PAYOFF.prefix}{" "}
                <span className="cursor-intercept-payoff-highlight">{INTERCEPT_PAYOFF.highlight}</span>{" "}
                {INTERCEPT_PAYOFF.suffix}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuietInterceptSection;
